$(document).ready(function() {

  // Image Gallery Section Slider
  
  var $slider = $('.image-gallery-division');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
     centerMode: true,
    centerPadding: '100px',
    slidesToShow: 1,
    arrows: false,
    // adaptiveHeight: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    dots:false,
    speed: 400,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '20px',
          slidesToShow: 1
        }
      }
    ]
  });  
});

$(document).ready(function(){
  
  // Product Page Accordion

  $('.accordion-data').click(function(){
    $(this).toggleClass('current');
    $(this).siblings().removeClass('current');
    $('.virtual-content').stop().slideUp();
    $('.current .virtual-content').stop().slideDown();
    return false;
  });

  // Youtube Videos Section Slider

  $('.youtube-videos-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    infinite: true,
    autoplay:true,
    arrows: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 16.5L1.25 9L8.75 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          infinite: true,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: true,
          arrows: false
        }
      }
    ]
  });
});


/* $(document).ready(function() {
  setTimeout(function(){
    if (window.location.href.indexOf("/pages/virtual-tasting#virtual-tasting-recordings") > -1) {
        $('html, body').animate({
            scrollTop : $('#virtual-tasting-recordings').offset().top
        }, 500);
    }
    },1000);
}); */